/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import PAText from "component/design-system/typography/PAText/PAText";
import matchMediaConst from "constant/matchmedia";
import { useCustomScreenSize } from "hoc/useScreenSize";
import { useTranslation } from "next-i18next";
import { useState, useEffect, useRef } from "react";
import { renderHTML } from "../../util/DomHelper";
import HideIf from "../../util/HideIf";
import { isEmpty } from "../../util/lodash/isEmpty";
import styles from "./style.module.scss";

interface IProps {
  data: any,
  showMore: boolean,
  style: any,
}

export default function ProductExtendedDescription(props: IProps) {
  const {
    data, showMore, style,
  } = props;
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const viewModeDivRef = useRef(null);
  const isMobile = useCustomScreenSize({
    maxWidth: matchMediaConst.XS_MAX,
  });
  const MOBILE_HEIGHT = 35;
  const DESKTOP_HEIGHT = 40;
  const { t } = useTranslation("common");

  useEffect(() => {
    if (viewModeDivRef && viewModeDivRef.current) {
      const { scrollHeight } = viewModeDivRef.current;
      if (isMobile) {
        setShowButton(scrollHeight > MOBILE_HEIGHT);
      } else {
        setShowButton(scrollHeight > DESKTOP_HEIGHT);
      }
    }
  }, []);

  function toggleExpand(e: any) {
    e.preventDefault();
    setExpanded((_expanded: any) => !_expanded);
  }

  let content = <span />;

  if (!isEmpty(data)) {
    if (Array.isArray(data)) {
      content = data.map((d, idx) => (
        <div
          key={idx}
          className={styles.product_extended_definition}
          dangerouslySetInnerHTML={renderHTML(d)}
        />
      ));
    }
    content = (
      <div
        className={styles.product_extended_definition}
        dangerouslySetInnerHTML={renderHTML(data)}
      />
    );

    if (showMore) {
      return (

        <div
          className={classNames(styles.faded_container, {
            [styles.show_all]: expanded,
            [styles.show_shrinked]: !expanded,
          })}

        >
          <div
            style={style}
            className={styles.content}
            ref={viewModeDivRef}
          >
            {content}
          </div>

          <HideIf show={showButton}>
            <div
              className={styles.faded_text}
            >
              <div className={classNames(styles.fade, {
                [styles.hide_fade]: expanded,
              })}
              />
              <a onClick={toggleExpand}>
                <i
                  className={`p-r-5 fa fa-angle-${expanded ? "up" : "down"}`}
                />
                <PAText component="span">
                  {expanded ? t("See less") : t("See more")}
                </PAText>

              </a>
            </div>
          </HideIf>
        </div>

      );
    }
  }
  return content;
}
